import { Tag } from 'antd';
import styled from 'styled-components';
import { RiskScale } from '@/styles/enum';
import { lightTheme } from '@/styles/themes/light';
import { customReportPaletteMap } from '@/utils/get-risk-range';
import type { Theme } from '@/styles/themes/types';

interface TagRiskProps {
	$result: RiskScale;
	$isBrightBackground: boolean;
}

export const LibertyMutualTag = styled(Tag)`
	width: 100%;
	padding: 4px 0px;
	border: 1px solid #2f54eb;
	background-color: #eaeefd;

	span {
		color: #2f54eb;
		font-weight: 600;
	}
`;

export const TagRisk = styled(Tag)<TagRiskProps>`
	border-radius: 5px;
	background-color: ${({ $result, theme }) => setTagBackGroundColor(theme || lightTheme, $result)};
	span {
		color: ${({ $isBrightBackground }) => ($isBrightBackground ? 'black' : 'white')};
	}
`;

function setTagBackGroundColor(theme: Theme, $result: RiskScale) {
	if ($result === 0) {
		return theme.colors.risk.low;
	}
	return customReportPaletteMap[$result] ?? theme.palette.secondary[250];
}
